import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className", "items"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import React from 'react';
import createBannerItem from '../factories/createBannerItem';
var style = {
  container: process.env.NODE_ENV === "production" ? {
    name: "1j9by5d",
    styles: "margin:0;padding:0;list-style-position:inside"
  } : {
    name: "1dk1snr-container",
    styles: "margin:0;padding:0;list-style-position:inside;label:container;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhbm5lckxpc3QudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFhIiwiZmlsZSI6Ii4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0Jhbm5lckxpc3QudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5cbmltcG9ydCB7IGNzcywganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcbmltcG9ydCBjcmVhdGVCYW5uZXJJdGVtIGZyb20gJy4uL2ZhY3Rvcmllcy9jcmVhdGVCYW5uZXJJdGVtJztcbmltcG9ydCB0eXBlIHsgQmFubmVyTGlzdFByb3BzIH0gZnJvbSAnLi4vdHlwZXMnO1xuXG5jb25zdCBzdHlsZSA9IHtcbiAgY29udGFpbmVyOiBjc3Moe1xuICAgIG1hcmdpbjogMCxcbiAgICBwYWRkaW5nOiAwLFxuICAgIGxpc3RTdHlsZVBvc2l0aW9uOiAnaW5zaWRlJyxcbiAgfSksXG59O1xuXG5jb25zdCBCYW5uZXJMaXN0OiBSZWFjdC5GQzxCYW5uZXJMaXN0UHJvcHM+ID0gKHtcbiAgY2hpbGRyZW4sXG4gIGNsYXNzTmFtZSxcbiAgaXRlbXMgPSBbXSxcbiAgLi4udW5oYW5kbGVkUHJvcHNcbn0pID0+IChcbiAgPHVsXG4gICAgey4uLnVuaGFuZGxlZFByb3BzfVxuICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgIGNzcz17c3R5bGUuY29udGFpbmVyfT5cbiAgICB7Y2hpbGRyZW4gIT0gbnVsbCA/IGNoaWxkcmVuIDogaXRlbXMubWFwKChpdGVtKSA9PiBjcmVhdGVCYW5uZXJJdGVtKGl0ZW0pKX1cbiAgPC91bD5cbik7XG5cbkJhbm5lckxpc3QuZGlzcGxheU5hbWUgPSAnQmFubmVyTGlzdCc7XG5cbmV4cG9ydCBkZWZhdWx0IEJhbm5lckxpc3Q7XG4iXX0= */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  }
};

var BannerList = function BannerList(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return jsx("ul", _extends({}, unhandledProps, {
    className: className,
    css: style.container
  }), children != null ? children : items.map(function (item) {
    return createBannerItem(item);
  }));
};

BannerList.displayName = 'BannerList';
export default BannerList;